module.exports = "../../../../platform/assets/pageMainIcon/business_jichudanganlei4.svg";